import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientTransactionsRoute } from '../route';

export const clientTransactionsFutureRoute = createRoute({
	path: '/future',
	getParentRoute: () => clientTransactionsRoute,
	component: lazyRouteComponent(
		() => import('./ClientTransactionsFuturePage'),
		'ClientTransactionFuturePage',
	),
	validateSearch: z.object({
		openedTransaction: z.string().optional(),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	}),
});
